<template>
    <div class="search">
        <form>
            <input v-model="message" v-on:change="fetchMovies" type="text" name="search" v-on:keydown.enter="fetchMovies" placeholder="Zoek naar een filmtitel..." > 
        </form>
        <p class="results" v-if="this.message != ''">Zoekresultaten voor '{{ message }}'.</p>
    </div>
</template>

<script>
export default {
    name: "Search",
    data() {
        return {
            message: '',
            api_key: '86b0b56b',
        }
    },
    methods: {
        fetchMovies (e) {
            e.preventDefault();
            fetch(`//www.omdbapi.com/?s=${this.message}&apikey=${this.api_key}`)
            .then(res => {
                return res.json();
            }).then(this.setResults);
        },
        setResults (results) {
            this.$emit("search", results);
        }
    }
}
</script>

<style scoped>
    .search form input {
        border: 1px solid #777575;
        width: 500px;
        padding: 10px 20px;
        border-radius: 3px;
        font-size: 12px;
        margin-top: 10px;
    }

    .search form {
        width: 100vw;
        background-color: #fff; 
    }

    form {
        display: flex;
        justify-content: center;
        margin-top: 5%;
    }

    .results {
        text-align: center;
        margin-top: 10px;
        padding: 0px;
    }

    @media only screen and (max-width: 580px) {
        .search form input {
            width: 80%;
        }
    }
</style>